// 大きなレイアウトシフト（CLS）の発生元を Clarity のカスタムタグに送る。
// Clarity のダッシュボードでは CLS の値しか分からず、どの要素がずれたか特定できないため。
// Clarity の録画フィルター「カスタムタグ」で cls_source / cls_context を指定して確認する。

// これ未満の小さなシフトは送らない（CLS の「良好」の目安は合計 0.1 未満）
const THRESHOLD = 0.05;
// 1 ページで送る件数の上限
const MAX_REPORTS = 3;

const describe = (node) => {
  const parts = [];
  for (let n = node; n && n.nodeType === 1 && parts.length < 3; n = n.parentElement) {
    let s = n.tagName.toLowerCase();
    if (n.id) s += `#${n.id}`;
    if (typeof n.className === "string" && n.className.trim()) {
      s += "." + n.className.trim().split(/\s+/).slice(0, 2).join(".");
    }
    parts.unshift(s);
  }
  return parts.join(">") || String(node && node.nodeName);
};

const rect = (r) =>
  `${Math.round(r.x)},${Math.round(r.y)} ${Math.round(r.width)}x${Math.round(
    r.height
  )}`;

export const startClsReporter = () => {
  if (typeof PerformanceObserver === "undefined") return;
  if (!PerformanceObserver.supportedEntryTypes?.includes("layout-shift")) return;

  let reported = 0;
  const observer = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      if (entry.hadRecentInput || entry.value < THRESHOLD) continue;
      if (reported >= MAX_REPORTS || typeof window.clarity !== "function") continue;
      reported += 1;

      const source = entry.sources?.[0];
      const detail = source
        ? `${entry.value.toFixed(2)} @${Math.round(entry.startTime)}ms ${describe(
            source.node
          )} ${rect(source.previousRect)} -> ${rect(source.currentRect)}`
        : `${entry.value.toFixed(2)} @${Math.round(entry.startTime)}ms (no source)`;
      window.clarity("set", "cls_source", detail.slice(0, 250));

      const nav = performance.getEntriesByType("navigation")[0];
      window.clarity(
        "set",
        "cls_context",
        `nav=${nav ? nav.type : "?"} sw=${Boolean(
          navigator.serviceWorker?.controller
        )} vw=${window.innerWidth}x${window.innerHeight}`
      );
    }
  });
  observer.observe({ type: "layout-shift", buffered: true });
};
